var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-form',[_c('el-form-item',{attrs:{"label":"当前广告系列"}},[_c('span',[_vm._v(_vm._s(_vm.campaignName)),_c('span',{staticStyle:{"color":"#F56C6C"}},[_vm._v("("+_vm._s(_vm.campaignId)+")")])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }